import React, { Suspense, lazy } from 'react';
import Select from "react-select";
import countryList from '../../../common/country-list.json';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Redirect } from 'react-router-dom';
import * as Yup from 'yup';
import { COMPANY_NAME_FULL, GET_PARENT, scrollTo, selectedStyles } from '../../../common';
import DonationEReceipt from './donation-e-receipt';
import AccountSuccess from './account-success';
import { config, validateForm } from '../../../common/constant';
import { GoogleApiWrapper } from 'google-maps-react';
import { GOOGLE_API_KEY_AUTOCOMPLETE } from '../../../../src/common/constant';
import { EnrollService } from '../../../jwt/_services/enrollment-service';
import { Common } from '../../../common/common';
import Loader from '../../MUIS/loader';
import { connect } from 'react-redux';
import * as user from '../../../redux/actions/userAction';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Pool from '../../../aws-pool/login-pool';
import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { AccountContext } from '../../../aws-pool/Account';
import { withTranslation } from "react-i18next";
import SearchPostalCode from './search-postalcode';
import i18n from "i18next";
import { eyePassword, eyePasswordOpen } from '../../../common/images-svg';
import { ARROW_BACK, MARK_EXCLAMATION, MARK_EXCLAMATION_17x17, TICK_CIRCLE_BIG } from '../../../common/images-s3';
import { profile } from '../../../jwt/_services/profile-service';
import Footer from '../../../section/footer/footer';
import { PaymentMethodHeader } from '../../../component/skip-enollment';

const PopupAccountVerificationPending = lazy(() => import('../../pop-up/popup-ac-verification-pending'));
const ForgotPassword = lazy(() => import('../../../section/header/forgot-password'));
const PopupWantToSignIn = lazy(() => import('../../pop-up/popup-want-sign-in'));
const PopupLogin = lazy(() => import('../../../section/header/popup-login'));
const PopupSignup = lazy(() => import('../../../section/header/popup-signup'));

const camelCaseTextConversion = (text) => {
    return text?.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

const ImageLoader = lazy(() => import('../../../common/image-loader'));
class EnrollCorporate extends React.Component {
    // static contextType = PageContext;
    static contextType = AccountContext;

    constructor(props) {
        super(props);
        const userData = Common.isValidField(this.props.user.userData) ? this.props.user.userData : {}
        // const phoneNumber = Common.isValidField(userData.phoneNumber) ? userData.phoneNumber.split(/(?:^\S+)\s/) : '';
        // const mobile = Common.isValidField(userData.mobile) ? userData.mobile.split(/(?:^\S+)/) : ''

        let phoneNumber = Common.isValidField(userData.phoneNumber)
            ? userData.phoneNumber.split(/^(\+)+(?:\S+)/)
            : Common.isValidField(userData.mobile)
                ? userData.mobile.split(/^(\+)+(?:\S+)/)
                : [''];

        phoneNumber = phoneNumber.length > 1 ? phoneNumber[phoneNumber.length - 1] : phoneNumber[0];

        const scope = this;

        this.state = {
            transactionNo: this.props.user.transactionNo ?? '',
            userId: this.props.user.userData.userId ?? '',
            userData: userData,
            isCreateAccount: false,
            countryDialCode: Common.isValidField(userData.countryCode) ? userData.countryCode : '+65',
            countryList: countryList.map((item, key) => {
                return { value: key, label: item.name }
            }),
            countryCodeList: countryList.sort((a, b) => a.name.localeCompare(b.name)).map((item, key) => {
                return { value: item.dial_code + ', ' + item.name + ', ' + item.length, label: <div className="div-option"><span className="name countryName"> {item.name}</span><span className="code">{item.dial_code}</span></div> }
            }),
            popupDetails: {
                "popupHeading": 'Unable to Proceed',
                "userEmail": "",
                "popupSubHeading": "Please login to the website to get Donation tax deduction and Receipt",
                "isButtonVisible": false,
                "buttonText": "Login to Web"
            },
            isLoading: false,
            receiptData: [],
            isShowEnrollForm: true,
            isAnonymousDisabled: false,
            emailExists: "",
            mobileExists: "",
            nricExists: "",
            multipleAccountExists: '',
            userFullName: userData.fullName ?? '',
            // isLoading: false,
            // receiptData: []
            initialValues: {
                representativeName: userData.representativeName ?? '',
                aliasName: '',
                companyName: userData.companyName ?? '',
                // acknowledgementName: userData.acknowledgementName ?? '',
                ckAnonymous: userData.ckAnonymous ?? false,
                mobile: Common.isValidField(phoneNumber) ? phoneNumber?.trim() : '',
                corporateEmail: userData.corporateEmail ?? userData.email ?? '',
                uen: userData.uen ?? '',
                countryOfBirth: '',
                dialect: '',
                nationality: '',
                dob: '',
                sex: '',
                password: '',
                confirmPassword: '',
                iAgree: true,
                address: "",
                streetandpostal: "",
                registeredAddress: scope.getRegisteredAddress(),
                buildingName: '',
                blockNumber: '',
                floorNo: '',
                unitNo: '',
            },
            disableDataFields: false,
            isSubmitDisabled: true,
            singPassErrorMessage: userData.singPassErrorMessage ?? null,
            isAdoptError: false,
            adoptErrorMsg: '',
            hideSkip: false,
            isGoogleSignedIn: false,
            isFacebookSignedIn: false,
            googleMessage: 'You have just signed in via Google',
            facebookMessage: 'You have just signed in via Facebook',
            address: userData.registeredAddress ?? userData.address ? userData.address : '',
            streetandpostal: userData.streetandpostal ?? '',
            pincode: '',
            // password
            showPassword: false,
            showConfirmPassword: false,

            // popups
            showLoginInPopup: false,
            showWantToSignInPopup: false,
            showForgotPasswordPopup: false,
            showAccountVerificationPopup: false,
            showSignUpPopup: false,

            // errors
            isUserNotConfirmed: false,

            // creds
            username: '',
            password: '',

            isVerificationLinkSent: false,

            currentUser: Pool.getCurrentUser(),
            isMobileNotEmpty: Common.isValidField(phoneNumber?.trim()),
            addressObj: userData.addressObj ? userData.addressObj : {
                "postalCode": "",
                "blockNumber": "",
                "streetName": "",
                "buildingName": "",
                "country": "",
                "unitNo": "",
                "floorNo": "",
            },
            isEmailRegistered: false,
        }

        this.refMobileField = React.createRef();
        this.refCountryCode = React.createRef();
        this.refMobile = React.createRef();
        this.refEnrollForm = React.createRef();

        this.onFocusShowSelected = this.onFocusShowSelected.bind(this);
        this.onBlurShowSelected = this.onBlurShowSelected.bind(this);
        this.getCountryDialCode = this.getCountryDialCode.bind(this);
        this.onClickCreateAccount = this.onClickCreateAccount.bind(this);
        this.showPassword = this.showPassword.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.handletext = this.handletext.bind(this);
        this.closePopUP = this.closePopUP.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.enrollView = this.enrollView.bind(this);
        this.closeBlockSocialLogin = this.closeBlockSocialLogin.bind(this);
        this.responseFacebook = this.responseFacebook.bind(this);
        this.responseGoogle = this.responseGoogle.bind(this);
        this.responseFailureGoogle = this.responseFailureGoogle.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
    }

    handleMenuClose() {
        document.activeElement.blur();
    }

    enrollView(isError) {
        if (isError) {
            this.setState({
                isAdoptError: true,
                isShowEnrollForm: false,
                isLoading: false
            })
        } else {
            this.setState({
                isAdoptError: false,
                isShowEnrollForm: true,
            })
        }
    }

    closeNotification() {
        this.setState({ singPassErrorMessage: null });
    }

    onAnonymousChnage = () => {
        this.setState({
            isAnonymousDisabled: !this.state.isAnonymousDisabled
        })
    }

    handletext(e) {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        } else {
            let data = e.target.value;
            let val = data.replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();
            e.target.value = val
        }
    }

    closePopUP() {
        this.setState({
            isSingupError: false
        })
    }

    handleNext() {
        if (this.refEnrollForm.current) {
            this.refEnrollForm.current.submitForm();
        }
        this.props.setHeaderData(PaymentMethodHeader)
        this.props.dispatch(user.updateUserSteps(PaymentMethodHeader));
        

    }
    handleSkip() {

    }

    onFormSubmit(values) {
        values.companyName = values.companyName.trim().replace(/\s\s+/g, ' ')
        values.fullname = values.representativeName.replace(/\s\s+/g, ' ')
        values.corporateEmail = values.corporateEmail.replace(/\s\s+/g, ' ');
        values.unitNo = Common.isValidField(this.state.address) ? String(this.state.address).replace(/\s\s+/g, ' ') : "";
        let uen = values.uen.replace(/\s\s+/g, ' ');

        this.setState({
            isLoading: true,
            initialValues: values
        })

        let mobileNumber = Common.isValidField(values.mobile) ? this.state.countryDialCode + " " + values.mobile : '';
        mobileNumber = mobileNumber.replace(/[A-Z]/gi, '');

        const addressObj = {
            "unitNo": values.unitNo ? values.unitNo : "",
            ...this.state.addressObj,
        }

        const enrollPayload = {
            "companyName": values.companyName,
            "name": values.representativeName,
            "email": values.email ?? values.corporateEmail,
            "phoneNumber": mobileNumber,
            "nric": uen,
            "isAnonymous": values.ckAnonymous,
            "onBehalfOf": values.onbehalfof,
            "type": config.ENROLL_CORPORATE_ID,
            "transactionNumber": this.state.transactionNo,
            "charityId": this.props?.homepage?.charityId ? this.props?.homepage?.charityId : config.MUIS_CHARITY_ID,
            "iAgree": values.iAgree,
            "dateOfBirth": values.dateofbirth,
            ...addressObj,
        }

        const flow = {
            representativeName: values.representativeName,
            flow: config.FLOW.MANUALLY,
            countryCode: this.state.countryDialCode,
            mobile: values.mobile,
            pincode: this.state.pincode,
            accountCreated: this.state.isCreateAccount,
            name: this.state.userData.name,
            registeredAddress: !values.registeredAddress ? (values.unitNo ? values.unitNo + ', ' + values.streetandpostal : values.streetandpostal || '').trim() : values.registeredAddress,
            addressObj: addressObj,
        };

        // remove password and confirm password
        delete values['password'];
        delete values['confirmPassword'];

        this.props.dispatch(user.updateUserData({
            ...this.state.userData,
            ...values,
            ...flow,
            email: values.corporateEmail,
            mobile: values.mobile ? this.state.countryDialCode + ' ' + values.mobile : '',
        }));

        this.donationEnrollment(enrollPayload);


    }

    donationEnrollment(payload) {
        this.setState({
            emailExists: "",
            mobileExists: "",
            nricExists: "",
            multipleAccountExists: ''
        })
        console.log(payload, 'payloadd')

    }

    onFocusShowSelected(e) {
        if (GET_PARENT(document.activeElement, null, 'select-form-control')?.id === this.refCountryCode.current.props?.id || document.activeElement === this.refMobile.current) {
            this.refMobileField.current.classList.add('focus');
        }
        setTimeout(() => {
            let ele = this.refMobileField.current;
            let menu = ele.querySelector('div[class$="-menu"]');
            if (menu) {
                menu.style.width = ele.offsetWidth + 'px';
                menu.style.opacity = 1;
            }
        }, 500);
        this.refMobileField.current.childNodes[2].value = document.getElementById('mobile').value.replace(/[A-Z]/gi, '');
    }

    onBlurShowSelected(e) {
        if (GET_PARENT(document.activeElement, null, 'select-form-control')?.id !== this.refCountryCode.current.props?.id && document.activeElement !== this.refMobile.current) {
            this.refMobileField.current.classList.remove('focus');
        }

        if (document.getElementsByClassName('countryName')[0]) {
            document.getElementsByClassName('countryName')[0].style.display = 'none';
            document.activeElement.blur();
        }

        this.setState({ isMobileNotEmpty: Common.isValidField(e?.target.value) });

        setTimeout(() => {
            this.refMobileField.current.childNodes[2].value = document.getElementById('mobile').value.replace(/[A-Z]/gi, '')
        }, 1);
    }

    getCountryDialCode(e) {
        let countryCode = e.value;
        this.setState({
            countryDialCode: countryCode.split(",")[0],
        });
        this.refMobileField.current.querySelector('input[name="mobile"]').focus();
    }

    onClickCreateAccount(status) {
        this.setState({ isCreateAccount: status });

        if (!status) {
            document.activeElement.blur();
            document.getElementById('iAgree').focus();
            setTimeout(() => document.getElementById('iAgree').blur(), 1)
        }
    }

    // showPassword(e) {
    //     let ele = e.target;
    //     let parent = GET_PARENT(ele, null, 'form-group');
    //     let iptPassword = parent.querySelector('input');
    //     if (iptPassword && iptPassword.getAttribute('type').toLowerCase() === 'password') {
    //         iptPassword.setAttribute('type', 'text');
    //         ele.parentNode.querySelector('button > img').src = eyePasswordOpen;
    //     } else {
    //         iptPassword.setAttribute('type', 'password');
    //         ele.parentNode.querySelector('button > img').src = eyePassword;
    //     }
    // }

    showPassword = ({ name }) => {
        switch (name) {
            case "password": {
                this.setState({
                    showPassword: !this.state.showPassword,
                });
                break;
            }
            case "confirmPassword": {
                this.setState({
                    showConfirmPassword: !this.state.showConfirmPassword,
                });
                break;
            }
            default:
                break;
        }
    }

    showLoginInPopup = (flag = true, isVerificationLinkSent = false) => {

        this.setState({
            showLoginInPopup: flag,
            isVerificationLinkSent: isVerificationLinkSent,
            showWantToSignInPopup: false,
            showForgotPasswordPopup: false,
            showAccountVerificationPopup: false,
            showSignUpPopup: false,
        });

    };

    showWantToSignInPopup = (flag = true) => {
        this.setState({
            showWantToSignInPopup: flag,
            showLoginInPopup: false,
            showForgotPasswordPopup: false,
            showAccountVerificationPopup: false,
            showSignUpPopup: false,
            isVerificationLinkSent: false,
        });

        // window.scrollTo({
        //     top: 0, behavior: 'smooth'
        // });
    }

    showForgotPasswordPopup = (flag = true) => {
        this.setState({
            showForgotPasswordPopup: flag,

            showLoginInPopup: false,
            showWantToSignInPopup: false,
            showAccountVerificationPopup: false,
            showSignUpPopup: false,
            isVerificationLinkSent: false,
        });

        // window.scrollTo({
        //     top: 0, behavior: 'smooth'
        // });
    }

    showAccountVerificationPopup = (flag = true) => {
        this.setState({
            showAccountVerificationPopup: flag,
            showLoginInPopup: false,
            showWantToSignInPopup: false,
            showForgotPasswordPopup: false,
            showSignUpPopup: false,
            isVerificationLinkSent: false,
        });

        // window.scrollTo({
        //     top: 0, behavior: 'smooth'
        // });
    }

    showSignUpPopup = (flag = true) => {
        this.setState({
            showSignUpPopup: flag,
            showAccountVerificationPopup: false,
            showLoginInPopup: false,
            showWantToSignInPopup: false,
            showForgotPasswordPopup: false,
            isVerificationLinkSent: false,
        });

        // window.scrollTo({
        //     top: 0, behavior: 'smooth'
        // });
    }

    resetAddressFields = () => {
        this.setState({
            addressObj: {
                "postalCode": "",
                "blockNumber": "",
                "streetName": "",
                "buildingName": "",
                "country": "",
                "unitNo": "",
                "floorNo": "",
            }
        })
    }

    // format and return registered address as string
    getRegisteredAddress = () => {
        const e = this.props.user.userData.addressObj
        let unit = `${e?.floorNo ? e?.floorNo + "-" : ""}${e?.unitNo ? e?.unitNo : ""}`.trim()
        if (config.REGEX.UNIT_NUMBER.test(unit)) {
            unit = `#${unit}`
        } else if (unit === "-" || unit === "00") {
            unit = ""
        }
        const address = `${e?.blockNumber ? e?.blockNumber : ""} ${e?.streetName ? e?.streetName + " " : ""}${unit ? unit + " " : ""}${e?.buildingName ? e?.buildingName + " " : ""}${e?.country ? e?.country : ""
            } ${e?.postalCode ? e?.postalCode : ""}`.trim();
        return address ? address : ""
    }

    componentDidMount() {
        this.setState({
            registerd_address_combined: this.state.address + this.state.userData.streetandpostal
        })
        const user = Pool.getCurrentUser();

        user && this.setState({ disableDataFields: true });

        if (Common.isValidField(this.state.initialValues.representativeName) && Common.isValidField(this.state.initialValues.email) && Common.isValidField(this.state.initialValues.uen)) {
            this.setState({
                isSubmitDisabled: false,
                isAnonymousDisabled: this.state.userData.isAnonymous
            })
        } else {
        }

        if (document.getElementsByClassName('countryName')[0]) {
            document.getElementsByClassName('countryName')[0].style.display = 'none';
        }

        this.state.initialValues?.corporateEmail && this.checkUserExistsByEmail(this.state.initialValues?.corporateEmail);

        setTimeout(() => scrollTo(), 200);
    }

    shouldComponentUpdate(newProps, newState) {
        const user = Pool.getCurrentUser();

        const nric = this.props.user.userData.nric;
        const uen = this.props.user.userData.uen;

        const nric1 = newProps.user.userData.nric;
        const uen1 = newProps.user.userData.uen;

        if (!Boolean(nric || uen) && Boolean(nric1 || uen1)) {
            const userData = Common.isValidField(newProps.user.userData) ? newProps.user.userData : {}

            let phoneNumber = Common.isValidField(userData.phoneNumber)
                ? userData.phoneNumber.split(/^(\+)+(?:\S+)/)
                : Common.isValidField(userData.mobile)
                    ? userData.mobile.split(/^(\+)+(?:\S+)/)
                    : [''];

            phoneNumber = phoneNumber.length > 1 ? phoneNumber[phoneNumber.length - 1] : phoneNumber[0];

            this.refEnrollForm.current.setValues({
                representativeName: userData.representativeName,
                aliasName: userData.aliasName,
                companyName: userData.companyName,
                // acknowledgementName: userData.acknowledgementName,
                ckAnonymous: userData.ckAnonymous,
                mobile: Common.isValidField(phoneNumber) ? phoneNumber?.trim() : '',
                corporateEmail: userData.corporateEmail || userData.email,
                uen: userData.uen,
                countryOfBirth: userData.countryOfBirth,
                dialect: userData.dialect,
                nationality: userData.nationality,
                dob: userData.dob,
                sex: userData.sex,
                password: '',
                confirmPassword: '',
                iAgree: userData.iAgree || true,
                address: userData.address,
                streetandpostal: "",
                registeredAddress: this.getRegisteredAddress()
            });

            this.setState({
                currentUser: user,
                disableDataFields: true,
            });
        }

        return true;
    }

    componentDidUpdate() {
        if (document.getElementsByClassName('countryName')[0]) {
            if (document.getElementsByClassName('countryName')[0].style.display !== 'none') {
                document.getElementsByClassName('countryName')[0].style.display = 'none';
            }
        }

    }

    handleChangeAddress = (address, setField) => {
        setField('streetandpostal', address);
        this.setState({ streetandpostal: address })
    }

    handleSelectAddress = (address, setField) => {
        address = address.split(this.state.pincode).join('');

        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                EnrollService.getPostalCodeFromGoogleAPI(latLng.lat, latLng.lng)
                    .then(results => {
                        const postalCode = results.address_components[results.address_components.length - 1].short_name;

                        this.setState({ streetandpostal: address + ' ' + postalCode, pincode: postalCode },
                            () => setField('streetandpostal', this.state.streetandpostal));
                    })
            })
            .catch(error => console.error('Error', error));
    };

    handleAddressErrors = (status, clearSuggestions, setFieldError) => {
        // setFieldError("address", `${status} found for ${this.state.address}`)
        // console.error(`${status} found for ${this.state.address}`)
        clearSuggestions();
    }

    responseGoogle = (response) => {
        let initialValues = { ...this.state.initialValues }
        initialValues.representativeName = response.name
        initialValues.corporateEmail = response.email;

        let uen = document.getElementById("uen").value.trim()

        const isValidUEN = uen !== "" ? String(uen).match(config.REGEX.NRIC) : false;

        this.setState({
            initialValues,
            isGoogleSignedIn: true,
            isSubmitDisabled: isValidUEN ? false : true
        })
    }

    responseFailureGoogle = (response) => {
        this.setState({ isGoogleSignedIn: false })
    }

    componentClicked = (data) => {
        console.warn(data)
    }

    responseFacebook = (response) => {
        let initialValues = { ...this.state.initialValues }
        initialValues.representativeName = response.name
        initialValues.corporateEmail = response.email

        let uen = document.getElementById("uen").value.trim()

        const isValidUEN = uen !== "" ? String(uen).match(config.REGEX.NRIC) : false;

        if (response.accessToken) {
            this.setState({
                initialValues,
                isFacebookSignedIn: true,
                isSubmitDisabled: isValidUEN ? false : true
            })
        } else {
            this.setState({ initialValues, isFacebookSignedIn: false })
        }
    }

    closeBlockSocialLogin() {
        document.querySelector('.c-socail-media-login.success-msg').style.display = 'none';
        this.setState({ isFacebookSignedIn: false, isGoogleSignedIn: false })
    }

    // Postal code API
    handleAddressChange = (address, postalCode, e) => {
        const addressObj = {
            ...e,
            streetName: camelCaseTextConversion(e?.streetName),
            buildingName: camelCaseTextConversion(e?.buildingName),
            country: e?.countryCode === "SG" ? "Singapore" : "",
        }
        delete addressObj['countryCode'];
        this.setState({ streetandpostal: address, pincode: postalCode, addressObj: addressObj })
    }

    checkUserExistsByEmail = (email) => {
        if (config.REGEX.EMAIL_ADDRESS.test(email) === false) return;
        profile.checkUserExistsByEmail(email)
            .then((res) => this.setState({
                isEmailRegistered: res.data?.isEmailExists,
                isCreateAccount: res.data?.isEmailExists ? false : this.state.isCreateAccount
            }))
    }

    render() {
        const { t } = this.props;

        // const searchOptions = {
        //     types: ['address'],
        //     componentRestrictions: { country: "sg" }
        // }

        return (
            <>
                {this.state.isLoading ? <div className="enroll-confirm-loader site-loader"><Loader /></div> : null}

                {this.state.isShowEnrollForm ?
                    <Formik
                        innerRef={this.refEnrollForm}
                        enableReinitialize={true}
                        initialValues={this.state.initialValues}
                        validationSchema={
                            Yup.object().shape({
                                corporateEmail: Yup.string().matches(config.REGEX.EMAIL_ADDRESS, 'Please enter valid corporate email').required('Please enter your email address'),
                                uen: Yup.string()
                                    .matches(config.REGEX.UEN1, t('Invalid_uen_err'))
                                    .min(9, t('Corporate_valid_uen_number'))
                                    .max(10, t('Corporate_valid_uen_number'))
                                    .required(t('Server_UEN_error')),
                                unitNo: Yup.string().when('streetandpostal', {
                                    is: (streetandpostal) => streetandpostal,
                                    then: Yup.string().required(""),
                                    otherwise: Yup.string()
                                }),
                                floorNo: Yup.string().when('streetandpostal', {
                                    is: (streetandpostal) => streetandpostal,
                                    then: Yup.string().required(""),
                                    otherwise: Yup.string()
                                }),
                            })
                        }
                        onSubmit={this.onFormSubmit}
                        validateOnChange
                        validateOnMount
                        validate={(values) => {
                            this.setState({
                                emailExists: "",
                                mobileExists: "",
                                nricExists: "",
                                multipleAccountExists: ''
                            })

                            const emailId = document.getElementById('corporateEmail');

                            let errors = {};

                            // if (values.streetandpostal && this.state.addressObj.blockNumber === "") {
                            //     errors.blockNumber = t('Validation_blockNumber');
                            // }

                            // if(values.streetandpostal && this.state.addressObj.buildingName === "") {
                            //     errors.buildingName = t('Validation_buildingName');
                            // }

                            values.mobile = values.mobile?.replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();

                            if (!values.mobile) {
                                errors.mobile = "Enter valid mobile number ";
                            } else {
                                let mobno = values.mobile;
                                mobno = mobno.replace(/\s/g, '');
                                if (mobno.length < 8) {
                                    errors.mobile = "Minimum 8 numbers";
                                } else if (mobno.length > 16) {
                                    errors.mobile = "Maxmium 16 numbers";
                                }
                            }

                            if (!values.registeredAddress && this.props.user.is3DSNeeded && String(values.unitNo).trim() === "") {
                                errors.unitNo = "Please enter House No. / Block / Unit No."
                            }

                            if (!values.registeredAddress && this.props.user.is3DSNeeded && String(values.streetandpostal).trim() === "") {
                                errors.streetandpostal = "Please enter Street Name / Postal Code"
                            }

                            if (!values.uen) {
                                errors.uen = t('Server_UEN_error');
                                document.getElementById('uen').classList.remove('is-invalid')
                            } else if (values.uen.length > 0 && config.REGEX.UEN1.test(values.uen) === false) {
                                document.getElementById('uen').classList.add('is-invalid');
                            } else if (String(values.uen).match(config.REGEX.UEN1)) {
                                document.getElementById('uen').classList.remove('is-invalid');
                            }


                            if (values.companyName.length > 0 && config.REGEX.REMOVE_COMPANY_NAME_EXTRA_SPACES.test(values.companyName) === false) {
                                document.getElementById('companyName').classList.add('is-invalid');
                                errors.companyName = t('Corporate_companyname_error');
                            } else if (values.companyName.length === 0) {
                                errors.companyName = t('Corporate_companyname_mandate');
                                document.getElementById('companyName').classList.remove('is-invalid');
                            } else if (values.companyName.length > 0 && config.REGEX.REMOVE_COMPANY_NAME_EXTRA_SPACES.test(values.companyName)) {
                                document.getElementById('companyName').classList.remove('is-invalid');
                            }

                            if (config.REGEX.EMAIL_ADDRESS.test(emailId.value) === false && values.corporateEmail.length > 0) {
                                errors.corporateEmail = t('ValidateForm_validEmail')
                                document.getElementById('corporateEmail').classList.add('is-invalid');
                            } else if (values.corporateEmail.length === 0) {
                                errors.corporateEmail = t('ValidateForm_validEmail_mandate')
                            } else {
                                document.getElementById('corporateEmail').classList.remove('is-invalid');
                            }

                            if (values.representativeName.length > 0 && config.REGEX.CONTACT_PERSON.test(values.representativeName) === false) {
                                errors.representativeName = t('Corporate_representativeName_error')
                                document.getElementById('representativeName').classList.add('is-invalid');
                            } else if (values.representativeName.length === 0) {
                                errors.representativeName = t('Corporate_representativeName_mandate');
                            } else {
                                document.getElementById('representativeName').classList.remove('is-invalid');
                            }

                            i18n.on("languageChanged", () => {
                                if (document.getElementById('companyName')) {
                                    document.getElementById('companyName').focus();
                                    setTimeout(() => document.getElementById('companyName').blur(), 10);
                                }
                            });

                            return errors;

                        }}
                    >
                        {({ values, errors, touched, isValid, dirty, setFieldTouched, setFieldValue, setFieldError, handleChange, setTouched, validateField }) => {
                            return (
                                <Form className="form">
                                    {/* arrow-back-red */}
                                    <div className="sec-enroll corporate">
                                        <div className="row">
                                            <div className="col-md-6 form-group">
                                                <label className="cust-label">{t('Corporate_company_name')} <span className="required">*</span></label>
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Corporate_enter_company_name')}
                                                    name="companyName"
                                                    id="companyName"
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        const value = e.target.value.toUpperCase();
                                                        setFieldValue('companyName', Common.trimExtraSpacesRemoveHTML(value));
                                                    }}
                                                    disabled={this.state.disableDataFields && this.state.initialValues.companyName}
                                                />
                                                {touched.companyName && errors.companyName ? <span className="invalid-feedback">{errors.companyName}</span> : null}
                                                {/* <ErrorMessage name="companyName">{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage> */}
                                            </div>
                                            <div className="col-md-6 form-group c-nric-fin">
                                                <label className="cust-label">{t('Corporate_UEN_no')} <span className="required">*</span></label>
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Corporate_enter_UEN_no')}
                                                    name="uen"
                                                    id="uen"
                                                    disabled={this.state.disableDataFields && this.state.initialValues.uen}
                                                    onChange={(ev) => {
                                                        handleChange(ev);
                                                        setFieldValue("uen", ev.target.value.toUpperCase());
                                                        this.setState({ uen: ev.target.value.toUpperCase() });
                                                    }}
                                                    data-sentry-mask
                                                />
                                                {touched.uen && errors.uen ? <span className="invalid-feedback">{errors.uen}</span> : null}
                                                {/* <ErrorMessage name="uen">{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage> */}
                                                {this.state.nricExists ? <span className="invalid-feedback">{this.state.nricExists}</span> : ''}
                                                {/* <div className="tax-note">To claim a tax deduction for donations of $50 and above</div> */}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 form-group">
                                                <label className="cust-label">{t('Corporate_name_contact_person')} <span className="required">*</span></label>
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Enrol_enter_name')}
                                                    name="representativeName"
                                                    id="representativeName"
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFieldValue('representativeName', value);
                                                    }}
                                                // disabled={this.state.disableDataFields && this.state.initialValues.representativeName}
                                                />
                                                {touched.representativeName && errors.representativeName ? <span className="invalid-feedback">{errors.representativeName}</span> : null}
                                                {/* <ErrorMessage name="representativeName">{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage> */}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 form-group c-mobile-number">
                                                <label className="cust-label">{t('Corporate_mobile_number')}&nbsp;{<span className='star'>*</span>}</label>
                                                <div ref={this.refMobileField} className={"c-fields " + (!errors.mobile && this.state.isMobileNotEmpty ? 'selected ' : '')}>
                                                    <Select
                                                        ref={this.refCountryCode}
                                                        name="countryCode"
                                                        id="countryCode"
                                                        placeholder="+65"
                                                        onChange={this.getCountryDialCode}
                                                        onFocus={(e) => this.onFocusShowSelected(e)}
                                                        onBlur={this.onBlurShowSelected}
                                                        onMenuClose={this.handleMenuClose}
                                                        isDisabled={this.state.disableDataFields}
                                                        className="select-form-control"
                                                        defaultValue={this.state.countryDialCode ? this.state.countryCodeList.filter((option) => option.value.split(",")[0] === this.state.countryDialCode) : ''}
                                                        // defaultValue={this.state.countryDialCode}
                                                        options={this.state.countryCodeList}
                                                        styles={selectedStyles}
                                                        maxMenuHeight={160}
                                                    />
                                                    <div className="v-line"></div>
                                                    {/* <Field type="text" className="form-control" placeholder="Mobile Number" onFocus={this.onFocusShowSelected} onBlur={this.onBlurShowSelected} name="mobile" /> */}
                                                    
                                                    <Field
                                                        innerRef={this.refMobile}
                                                        type="tel"
                                                        className="form-control"
                                                        onPaste={(e) => Common.formatNumber(e)}
                                                        placeholder={t('Corporate_enter_mobile_number')}
                                                        onKeyPress={this.handletext}
                                                        onFocus={(e) => this.onFocusShowSelected(e)}
                                                        // onBlur={(e) => this.onBlurShowSelected(e)}
                                                        onBlur={(e) => {
                                                            setFieldTouched('mobile', true);
                                                            this.onBlurShowSelected(e)}}
                                                        name="mobile"
                                                        id="mobile"
                                                        data-sentry-mask
                                                    //disabled={this.state.disableDataFields}    
                                                    />
                                                </div>
                                                {/* <ErrorMessage name="mobile">{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage> */}
                                                {/* {errors.mobile !== '' ? <span className="invalid-feedback">{errors.mobile}</span> : ''} */}
                                                {touched.mobile && errors.mobile ? <span className="invalid-feedback">{errors.mobile}</span> : null}

                                                {this.state.mobileExists ? <span className="invalid-feedback">{t('Enrol_mobile_exists_error')}</span> : ''}
                                            </div>
                                            <div className="col-md-6 form-group">
                                                <label className="cust-label">{t('Enrol_email_address')} <span className="required">*</span></label>
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Enrol_enter_email_address')}
                                                    id="corporateEmail"
                                                    name="corporateEmail"
                                                    disabled={this.state.disableDataFields}
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFieldValue('corporateEmail', value);
                                                        // this.checkUserExistsByEmail(e.target.value);
                                                    }}
                                                />
                                                {touched.corporateEmail && errors.corporateEmail ? <span className="invalid-feedback">{errors.corporateEmail}</span> : null}
                                                {/* <ErrorMessage name="corporateEmail">{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage> */}
                                                {this.state.emailExists !== '' ? <span className="invalid-feedback">{this.state.emailExists}</span> : ''}
                                            </div>
                                        </div>
                                        {!values.registeredAddress ?
                                            <div className="row">
                                                {/* <div className="col-lg-6 form-group">
                                             <label className="cust-label">House No. / Block / Unit No.&nbsp;{this.props.user.is3DSNeeded && <span className='star'>*</span>}</label>
                                             <Field type="text" className="form-control" placeholder="Enter house no. / block / unit no." name="address" onChange={(ev)=>{
                                                 handleChange(ev);
                                                 setFieldValue("address", ev.target.value);
                                                 this.setState({address: ev.target.value});
                                             }}/>
                                             <ErrorMessage name='address'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                         </div> */}
                                                <div className="col-md-6 form-group c-postal-code">

                                                    <label className="cust-label">{t('Enrol_singapore_postal_code')}&nbsp;{this.props.user.is3DSNeeded && <span className='star'>*</span>}</label>
                                                    {/* <Field type="text" className="form-control" placeholder="Enter Registered Address" name="address" /> */}
                                                    {/* <PlacesAutocomplete
                                                    value={this.state.streetandpostal}
                                                    onChange={(val) => this.handleChangeAddress(val, setFieldValue)}
                                                    onSelect={(value) => this.handleSelectAddress(value, setFieldValue)}
                                                    onError={(status, clearSuggestions) => this.handleAddressErrors(status, clearSuggestions, setFieldError)}
                                                    searchOptions={searchOptions}
                                                >
                                                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                        //<Field type='text' name='street1' id='street1' placeholder="Enter Delivery Address" className='form-control' />
                                                        <div>
                                                            <input
                                                                name="streetandpostal"
                                                                id='streetandpostal'
                                                                onBlur={() => setFieldTouched('streetandpostal', true)}
                                                                {...getInputProps({
                                                                    className: "form-control", placeholder: "Enter street name / postal code", onBlurCapture: () => setFieldTouched('streetandpostal', true, true)
                                                                })}
                                                            />
                                                            <div className="autocomplete-dropdown-container">
                                                                {loading && <div></div>}

                                                                {suggestions.map((suggestion, index) => {
                                                                    const className = suggestion.active
                                                                        ? 'suggestion-item--active'
                                                                        : 'suggestion-item';
                                                                    // inline style for demonstration purpose
                                                                    const style = suggestion.active
                                                                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                                    return (
                                                                        <div
                                                                            key={'suggestion-item' + '-' + index}
                                                                            {...getSuggestionItemProps(suggestion, {
                                                                                className,
                                                                                style,
                                                                            })}
                                                                        >
                                                                            <span>{suggestion.description}</span>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}
                                                </PlacesAutocomplete> */}
                                                    <SearchPostalCode handleAddressChange={this.handleAddressChange} setField={setFieldValue} t={t} />
                                                    <ErrorMessage name='streetandpostal'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div>
                                                 <div className="col-md-6 form-group">
                                                    <label className="cust-label">{t('Enrol_buildingName')}</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.BUILDING_NAME}
                                                        placeholder={t('Enrol_enter_buildingName')}
                                                        value={this.state.addressObj.buildingName}
                                                        name="buildingName"
                                                        id="buildingName"
                                                        onChange={(ev) => {
                                                            handleChange(ev);
                                                            if (ev.target.value) {
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                        ...prevState.addressObj,
                                                                        buildingName: ev.target.value,
                                                                    }
                                                                }));
                                                            } else {
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                        ...prevState.addressObj,
                                                                        buildingName: "",
                                                                    }
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name='buildingName'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div> 
                                               <div className="col-md-6 form-group">
                                                    <label className="cust-label">{t('Enrol_blockNumber')}&nbsp;{values.streetandpostal && <span className='star'>*</span>}</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.BLOCK}
                                                        placeholder={t('Enrol_enter_blockNumber')}
                                                        value={this.state.addressObj.blockNumber}
                                                        name="blockNumber"
                                                        id="blockNumber"
                                                        onChange={(ev) => {
                                                            const trimmedValue = String(ev.target.value).trim();
                                                            handleChange(ev);
                                                            if (trimmedValue) {
                                                                // this.setState({ blockNumber:  trimmedValue });
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                        ...prevState.addressObj,
                                                                        blockNumber: trimmedValue,
                                                                    }
                                                                }));
                                                            } else {
                                                                // this.setState({ blockNumber:  '' });
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                        ...prevState.addressObj,
                                                                        blockNumber: trimmedValue,
                                                                    }
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name='blockNumber'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div> 
                                                 <div className="col-md-3 form-group c-floor-no">
                                                    <label className="cust-label">{t('Enrol_floorNo')}&nbsp;{values.streetandpostal && <span className='star'>*</span>}</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.UNIT_NO}
                                                        placeholder={t('Enrol_enter_floorNo')}
                                                        name="floorNo"
                                                        id="floorNo"
                                                        onChange={(ev) => {
                                                            const trimmedValue = String(ev.target.value).trim();
                                                            handleChange(ev);
                                                            if (trimmedValue === "") {
                                                                setFieldError('floorNo', t('Validation_floorNo'));
                                                                // this.setState({ floorNo: '' });
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                        ...prevState.addressObj,
                                                                        floorNo: trimmedValue,
                                                                    }
                                                                }));
                                                            } else {
                                                                setFieldValue("floorNo", trimmedValue);
                                                                // this.setState({ floorNo: trimmedValue });
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                        ...prevState.addressObj,
                                                                        floorNo: trimmedValue,
                                                                    }
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name='floorNo'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                    {
                                                        values.streetandpostal && <span className="addrs-note-1">{t('Enrol_info_text')}</span>
                                                    }
                                                </div> 
                                                <div className="col-md-3 form-group mb-0">
                                                    <label className="cust-label">{t('Unit_no')}&nbsp;{values.streetandpostal && <span className='star'>*</span>}</label>
                                                    <Field
                                                        type="number" className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.UNIT_NO}
                                                        placeholder={t('Enrol_enter_unit_no')}
                                                        name="unitNo"
                                                        onChange={(ev) => {
                                                            if (ev.target.value === '#') return;
                                                            handleChange(ev);
                                                            setFieldValue("unitNo", ev.target.value);
                                                            this.setState({ address: ev.target.value });
                                                        }} />
                                                    <ErrorMessage name='unitNo'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>

                                                    {
                                                        values.streetandpostal && <span className="addrs-note-1">{t('Enrol_info_text')}</span>
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div className="row">
                                                <div className="col-lg-12 form-group">
                                                    <label className="cust-label">{t('Enrol_registered_address')}&nbsp;{this.props.user.is3DSNeeded && <span className='star'>*</span>}</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter registered address"
                                                        name="registeredAddress"
                                                        id="registeredAddress"
                                                        value={values.registeredAddress}
                                                        onChange={(ev) => {
                                                            setFieldValue("unitNo", '');
                                                            setFieldValue("registeredAddress", '');
                                                            setFieldValue("streetandpostal", '');
                                                            this.resetAddressFields();

                                                        }} />
                                                    <ErrorMessage name='registeredAddress'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div>
                                            </div>
                                        }

                                        <div>
                                                <Footer
                                                    isSkipButtonVisible={false}
                                                    handleNext={this.handleNext}
                                                    handleSkip={this.handleSkip}
                                                    disabled={((!isValid && !dirty && this.state.isSubmitDisabled) ||
                                                        this.state.isCreateAccount
                                                        ? !(values?.password?.trim().length && values?.confirmPassword?.trim().length)
                                                        : false) || !!Object.keys(errors).length
                                                    }
                                                />
                                        </div>
                                    </div>
                                </Form>)
                        }}
                    </Formik> : <Redirect to={{ pathname: '/' }} push={true} />
                }

                {this.state.isShowDonationReceipt ? <DonationEReceipt data={this.state.receiptData}>  </DonationEReceipt> : null}

            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.userReducer,
        homepage: state.homepageReducer,
    }
}

export default GoogleApiWrapper({
    apiKey: (GOOGLE_API_KEY_AUTOCOMPLETE)
})(connect(mapStateToProps)(withTranslation()(EnrollCorporate)));